import { React, useState, useMemo } from 'react';
import axios from 'axios';

import Banner from '../banner/Banner';

import './DataDownload.scss';
import config from '../../config/config.json';

function DataDownload(props) {

    const sortIconDefault = <div className="sort-icon-container"><i className="fa fa-sort"></i></div>;
    const sortIconAscending = <div className="sort-icon-container"><i className="fa fa-sort-down"></i><i className="fa fa-sort-up"></i></div>;
    const sortIconDescending = <div className="sort-icon-container"><i className="fa fa-sort-up"></i><i className="fa fa-sort-down"></i></div>;

    const [sortConfig, setSortConfig] = useState('productName', 'ascending');
    const [productSortIcon, setProductSortIcon] = useState(sortIconDefault);
    const [dateSortIcon, setDateSortIcon] = useState(sortIconDefault);

    const useSortedData = () => {
        const sortedItems = useMemo(() => {
            let sortableItems = [...JSON.parse(localStorage.getItem('PACKAGES')).packageDetails];
            if (sortConfig !== null) {
                sortableItems.sort((a, b) => {
                    if (a[sortConfig.key] < b[sortConfig.key]) {
                        return sortConfig.direction === 'ascending' ? -1 : 1;
                    }
                    if (a[sortConfig.key] > b[sortConfig.key]) {
                        return sortConfig.direction === 'ascending' ? 1 : -1;
                    }
                    return 0;
                });
            }
            return sortableItems;
        }, [sortConfig]);

        const requestSort = (key) => {
            let direction = 'ascending';
            if (
                sortConfig &&
                sortConfig.key === key &&
                sortConfig.direction === 'ascending'
            ) {
                direction = 'descending';
            }
            setSortConfig({ key, direction });
            sortHandler(key, direction);
        };
        return { items: sortedItems, requestSort, sortConfig };
    };

    const { items, requestSort } = useSortedData();

    const sortHandler = (key, direction) => {
        if (key === 'productName') {
            if (direction === 'ascending') {
                setProductSortIcon(sortIconAscending);
            } else if (direction === 'descending') {
                setProductSortIcon(sortIconDescending);
            } else {
                setProductSortIcon(sortIconDefault);
            }
            setDateSortIcon(sortIconDefault);
        }
        if (key === 'packageDate') {
            if (direction === 'ascending') {
                setDateSortIcon(sortIconAscending);
            } else if (direction === 'descending') {
                setDateSortIcon(sortIconDescending);
            } else {
                setDateSortIcon(sortIconDefault);
            }
            setProductSortIcon(sortIconDefault);
        }
    };

    function getProducts() {
        if (items.length === 0) {
            // use default (unsorted) products
            return JSON.parse(localStorage.getItem('PACKAGES')).packageDetails;
        } else {
            // use sorted products
            return items;
        }
    }

    // API request
    async function downloadProductFile(guid, productId, fileName, onProgress) {
        try {

            const baseurl = props.env.USE_LOCAL === "true" ? config.apiLocalHost : props.env.BASE_URL;

            const url = baseurl +
                `v${props.env.API_VERSION}/${guid}/${productId}/${fileName}/DownloadProduct` +
                `?api-version=${props.env.API_VERSION}.0`;              

            const response = await fetch(url);

            if (!response.ok) {
                console.log('Response not OK:', response.status, response.statusText);
                return null;
            }

            const contentLength = response.headers.get('content-length');
            const total = contentLength ? parseInt(contentLength, 10) : null;

            const reader = response.body.getReader();
            const chunks = [];

            let received = 0;

            while (true) {
                const { done, value } = await reader.read();
                if (done) break;

                chunks.push(value);
                received += value.length;

                if (total && onProgress) {
                    onProgress(Math.round((received / total) * 100));
                }
            }

            const blob = new Blob(chunks);
            return blob;

        } catch (error) {
            console.log('Fetch error:', error);
            return null;
        }
    }

    async function downloadProductFileHandler(productId, fileName) {
        let guid = localStorage.getItem('GUID');
        let buttonId = 'downloadButton_' + productId;
        let buttonElement = document.getElementById(buttonId);

        buttonElement.disabled = true;
        buttonElement.innerHTML = "Starting Download..";

        const blob = await downloadProductFile(
            guid,
            productId,
            fileName,
            (progress) => {
                buttonElement.innerHTML = `Downloading ${progress}%`;
            }
        );

        if (!blob || blob.size === 0) {
            console.log(`No data received for file ${fileName} of product ${productId}`);
            buttonElement.disabled = false;
            buttonElement.innerHTML = "Download";
            return;
        }

        const objectUrl = URL.createObjectURL(blob);
        const downloadAnchor = document.createElement('a');

        downloadAnchor.href = objectUrl;
        downloadAnchor.download = fileName;
        downloadAnchor.style.display = 'none';

        document.body.appendChild(downloadAnchor);
        downloadAnchor.click();
        document.body.removeChild(downloadAnchor);
        setTimeout(() => URL.revokeObjectURL(objectUrl), 1000);

        buttonElement.disabled = false;
        buttonElement.innerHTML = "Download";
    }


    return (
        <div>
            <div className="product-download-container">
                <Banner />
                <table className="product-download-table">
                    <thead>
                        <tr>
                            <th className="sortable-header product-name" onClick={() => requestSort('productName')}>
                                {productSortIcon}
                                <span className='table-header-name'>Product</span>
                            </th>
                            <th className="sortable-header" onClick={() => requestSort('packageDate')}>
                                {dateSortIcon}
                                <span className='table-header-name'>Last Update</span>
                            </th>
                            <th className="plain-header">Data</th>
                        </tr>
                    </thead>
                    <tbody>
                        {getProducts().map((product) => (
                            <tr key={product.productID}>
                                <td>{product.productName}</td>
                                <td>{product.packageDate.substring(0, 10)}</td>
                                <td>
                                    <button
                                        id={`downloadButton_${product.productID}`}
                                        onClick={() => downloadProductFileHandler(product.productID, product.packageFilename)}
                                    >
                                        Download
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
}

export default DataDownload;
